import { assign } from 'lodash';
import createReducer from './baseReducer';

const conditions = {
  REQUEST_VEHICLE: (state, data, error, id) => {
    return assign({}, state, {
      isFetching: true,
      didInvalidate: false,
      lastVehicle: id,
    });
  },
};

const extraState = {
  lastVehicle: -1,
};

export default createReducer(
  'vehicles',
  'vehicle',
  'vehicles',
  conditions,
  extraState,
);
